/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum HistoricoAutorizacoesAliases {
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  CUSTOM_CARD = 'custom-card',
  DATE_FIELD_0 = 'date-field-0',
  DATE_FIELD_1 = 'date-field-1',
  DECK = 'deck',
  FETCH_0 = 'fetch-0',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  FIELD_4 = 'field-4',
  FIELD_5 = 'field-5',
  FIELD_6 = 'field-6',
  FIELD_7 = 'field-7',
  FIELD_8 = 'field-8',
  FIELD_9 = 'field-9',
  FILTER = 'filter',
  FILTERED_LIST_0 = 'filtered-list-0',
  INPUT_0 = 'input-0',
  LAYOUT_HISTORICO_AUTORIZACOES = 'layout-historico-autorizacoes',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_4 = 'text-4',
  TEXT_5 = 'text-5',
  TEXT_6 = 'text-6',
}
export { HistoricoAutorizacoesAliases };
